module.exports = __webpack_public_path__ + "static/media/addCompanyIcon.0993a140.svg";